import React from 'react'
import { privacy_notice } from 'utils/constants/data'

function PrivacyNotice() {
    return (
        <section>
            <div className='max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl mx-auto px-4 py-4 sm:py-12 space-y-8 mt-28 md:mt-32 lg:mt-36'>
                <div className='space-y-2 sm:space-y-4'>
                    <p className='text-3xl sm:text-4xl lg:text-5xl font-bold'>Privacy Notice</p>
                </div>
                {privacy_notice.map((item, i) => (
                    <div className='space-y-4 sm:space-y-6 lg:space-y-8'>
                        {item?.title && (
                            <p className='text-xl sm:text-2xl lg:text-3xl font-bold'>{item.title}</p>
                        )}
                        {item?.description && (
                            <div className='text-base sm:text-lg lg:text-xl xl:text-2xl text-justify space-y-4 md:space-y-6'>
                                {item.description}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>

    )
}

export default PrivacyNotice